let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("iDm4w")]).then(() => parcelRequire('8nrlS'));